import "../CSS/Footer.css";
function Footer() {
  return (
    <div className="Footer">
      <p>
        &copy;<span>Ahmed Samir </span>All Rights has been reserved
      </p>
    </div>
  );
}
export default Footer;
